//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TitlePrice',
  props: {
    isSubscriptionPrice: {
      type: Boolean,
      required: true
    },
    productLine: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    discontinuedProduct: {
      type: Boolean,
      default: false
    },
    secondaryTitle: {
      type: String,
      default: ''
    },
    itemLabel: {
      type: String,
      default: ''
    },
    sku: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    points: {
      type: Object,
      default: () => ({})
    },
    showPoints: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: 0
    },
    priceLabel: {
      type: String,
      default: ''
    },
    originalPrice: {
      type: Number,
      default: 0
    },
    originalPriceLabel: {
      type: String,
      default: ''
    },
    subscriptionPrice: {
      type: Number,
      default: 0
    },
    subscriptionPriceLabel: {
      type: String,
      default: ''
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    currencyCode: {
      type: String,
      default: ''
    },
    priceType: {
      type: String,
      default: ''
    },
    originalPriceType: {
      type: String,
      default: ''
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    market: {
      type: String,
      default: ''
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    },
    /**
     * If isActiveSubscriber is true:
     * Display subscription pricing from the graphql
     * If the subscription price is less than the buy once price
     * show the original retail/wholesale price crossed out and
     * show the buy once price to be the same as the subscription price
     */
    isActiveSubscriber: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currencyLocale() {
      return this.$store.getters['nuskin/currencyLocale'] || '';
    },
    priceAmount() {
      return this.formatCurrency(this.price);
    },
    originalPriceAmount() {
      return this.formatCurrency(this.originalPrice);
    },
    subscriptionPriceAmount() {
      return this.formatCurrency(this.subscriptionPrice);
    },
    tabletAndUp() {
      return (
        this.$mq === 'tablet' ||
        this.$mq === 'desktop' ||
        this.$mq === 'desktopHD'
      );
    }
  },
  methods: {
    formatCurrency(value) {
      if (!this.currencyCode || !this.currencyLocale) {
        console.warn(
          `[Catalog] Currency unknown. Code ['USD']: '${this.currencyCode}', Locale ['en-US']: '${this.currencyLocale}'.`
        );
      }
      return Intl.NumberFormat(this.currencyLocale || 'en-US', {
        style: 'currency',
        currency: this.currencyCode || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(typeof value === 'object' ? 0 : value || 0);
    }
  }
};
